import React, { useEffect, useState } from "react";
import { DatePicker } from "../../../../../../../../react-core/Datepicker/DatePicker";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { ContentDatePicker } from "../../../../../../../Shared/Entities/Constants/DateConstants";
import { Action } from "../../../../../../Actions/Action";
import { MoneyIcon } from "../Icon/MoneyIcon";
import AdviserSiteTagManager, { eventCategoryForGTM } from "../../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { DateOptions } from "../../../../../../../Shared/Components/Resource/Contents";
import { DateRange } from "../../../../../../../Shared/Components/DateRange";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";

interface ITotalPayeIncomeProps {
    headaccount?: ClientAccount;
    subAccountHierarchyId: string;
}

export const TotalPayeIncome = (props: ITotalPayeIncomeProps) => {

    const ACCEPT_DATE_FORMATS = ["yyyy.MM.dd", "yyyy/MM/dd", "yyyy-MM-dd", "yyyyMMdd"];

    const [dateFrom, setDateFrom] = useState(() => {
        const date = new Date();
        date.setFullYear(date.getFullYear() - 1);

        if (props.headaccount?.InceptionDate && JsonDateParser.isValidDate(props.headaccount?.InceptionDate)) {
            const inceptionDate = JsonDateParser.toDate(props.headaccount.InceptionDate);
            inceptionDate.setDate(inceptionDate.getDate() - 1);
            return inceptionDate;
        }
        return date;
    });

    const [dateTo, setDateTo] = useState(new Date());
    const [dateSelected, setDateSelected] = useState("Since account opening");
    const [drawdownIncomeHistoryData, setDrawdownIncomeHistoryData] = useState(null);


    const handleDateFromChange = (selectedDate) => {
        setDateFrom(selectedDate);
    };

    const handleDateToChange = (selectedDate) => {
        setDateTo(selectedDate);
    };
    const addEvent = new AdviserSiteTagManager().addEvent;
    useEffect(() => {
        Action.getDrawdownIncomeHistory(
            props.subAccountHierarchyId,
            JsonDateParser.toJsonDateNoOffset(dateFrom),
            JsonDateParser.toJsonDateNoOffset(dateTo),
            (val) => {
                setDrawdownIncomeHistoryData(val);
            });

        return () => {
            setDrawdownIncomeHistoryData(null);
        };
    }, [dateFrom, dateTo, props.subAccountHierarchyId]);

    return (
        <>
            <div className="row">
                <div className="col-fluid">
                    <h3>Income payments</h3>
                </div>
            </div>
            <DateRange
                minDate={JsonDateParser.toDate(props.headaccount?.InceptionDate)}
                fromDate={dateFrom}
                toDate={dateTo}
                cssGridDate="col-12 col-sm-auto"
                cssGridTo="col-fluid col-max-180"
                cssGridFrom="col-fluid col-max-180"
                cssGridLabel="col-12 col-sm-auto col-middle"
                selectValue={dateSelected}
                onChange={(
                    fromDate: Date,
                    toDate: Date,
                    fromInception: boolean,
                    dateSelected: string
                ) => {
                    addEvent({
                        event: "productOverviewValuationAndIncomeTab_interaction",
                        eventParameters: {
                            eventAction: "date range selector",
                            eventCategory: eventCategoryForGTM.totalIncomePayeeTab,
                            eventLabel: CommonHelper.getOptionsTxt(
                                dateSelected,
                                DateOptions
                            ).toLowerCase(),
                        },
                    });
                    handleDateFromChange(fromDate);
                    handleDateToChange(toDate);
                    setDateSelected(dateSelected);
                }}
            />
            <div className="panel-total-income">
                <div className="total-row">
                    <div className="description">
                        <p>Total PAYE Gross Income</p>
                        <p className="figure">£{drawdownIncomeHistoryData?.TotalGross?.Amount}</p>
                    </div>
                    <div className="icon" aria-hidden="true">
                        <MoneyIcon />
                    </div>
                </div>
                <hr className="row-divider" />
                <div className="total-row">
                    <div className="description">
                        <p>Total PAYE Tax</p>
                        <p className="figure">£{drawdownIncomeHistoryData?.TotalPaye?.Amount}</p>
                    </div>
                    <div className="icon" aria-hidden="true">
                        <MoneyIcon />
                    </div>
                </div>
            </div>
        </>
    );
};
